var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"border":"","columns":_vm.columns,"data":_vm.tableData,"no-data-text":"<div class='table-no-data'></div>","height":_vm.utils.setTableHeight(100)},scopedSlots:_vm._u([{key:"filesArr",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [(row.filesArr)?_c('viewer',_vm._l((row.filesArr),function(x,index){return _c('img',{key:index,staticStyle:{"margin-right":"4px","cursor":"pointer"},attrs:{"src":_vm.axios.platConfig.fileUri + x,"width":"24","height":"24"}})}),0):_vm._e()]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebc2b7ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wuliu/caiwu/shouzhijiluList.vue
// module id = null
// module chunks = 